module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/by-da99aaa559633b439aa30c100f14cfbb.svg";